export default __webpack_public_path__ + "e3b6188cd79f3c06e21b7795a841c565.svg";